import React, { Fragment } from 'react'
import { Button, CircularProgress, Typography } from '@material-ui/core'
import ConfigSectionContent from './ConfigSectionContent'
import ConfigSidebar from './ConfigSidebar'
import { useCoreConfigEditor } from './hooks'
import { useStyles } from './styles'

export default function ExaminerConfigurationsList() {
    const classes = useStyles()
    const {
        parents,
        activeSection,
        activeSectionId,
        expandedParents,
        expandedGroups,
        loading,
        saving,
        resetting,
        error,
        success,
        updateFieldValue,
        toggleParent,
        toggleGroup,
        selectSection,
        saveConfig,
        runFieldAction,
    } = useCoreConfigEditor()

    if (loading) {
        return <CircularProgress />
    }

    return (
      <Fragment>
          <div className={classes.root}>
              <ConfigSidebar
                parents={parents}
                activeSectionId={activeSectionId}
                expandedParents={expandedParents}
                onToggleParent={toggleParent}
                onSelectSection={selectSection}
                classes={classes}
              />

              <div className={classes.content}>
                  <ConfigSectionContent
                    section={activeSection}
                    expandedGroups={expandedGroups}
                    onToggleGroup={toggleGroup}
                    onFieldChange={updateFieldValue}
                    onFieldAction={runFieldAction}
                    actionPending={resetting}
                    classes={classes}
                  />
              </div>
          </div>

          <div className={classes.footer}>
              <Button
                variant="contained"
                color="primary"
                onClick={saveConfig}
                disabled={saving}
              >
                  {saving ? 'Saving...' : 'Save Config'}
              </Button>
              {error && (
                <Typography className={classes.messageError}>{error}</Typography>
              )}
              {success && (
                <Typography className={classes.messageSuccess}>{success}</Typography>
              )}
          </div>
      </Fragment>
    )
}
